<template>
  <div class="account-menu">
    <template v-if="isSwitched">
        <p class="account-menu__item title is-6"
           :class="classes"
           style="line-height: 1.3rem" :title="loggedInAs">
          Logged in as {{ loggedInAs }}
        </p>
        <p class="account-menu__item subtitle is-7"
           :class="classes" :title="userEmail">
          {{ userEmail }}
        </p>
    </template>
    <template v-else>
      <p class="account-menu__item title is-6" :class="classes">{{ fullName }}</p>
      <p class="account-menu__item subtitle is-7" :class="classes">{{ email }}</p>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'AccountName',
  props: {
    classes: Array,
  },

  computed: {
    ...mapGetters(['isSwitched']),
    ...mapGetters('auth2', ['fullName']),
    ...mapState('auth2', ['email']),
    ...mapState({
      contractorCompanyName: (state) => state.contractor.companyName,
      userEmail: (state) => state.user.email,
      partnerId: (state) => state.partner.id,
      partnerFirstName: (state) => state.partner.firstName,
      partnerLastName: (state) => state.partner.lastName,
    }),
    loggedInAs() {
      return this.partnerId
        ? `${this.partnerFirstName} ${this.partnerLastName}`
        : this.contractorCompanyName;
    },
  },

};
</script>

<style lang="stylus" scoped>
  .account-menu
    display flex
    flex-direction column
    align-items flex-end
    justify-content center

  .account-menu
    &__item
      max-width 500px
      overflow hidden
      white-space nowrap
      text-overflow ellipsis
      @media screen and (max-width: 768px)
        max-width 100%
        white-space normal
      @media screen and (min-width: 1023px)
        max-width 350px

</style>
